// Chamadas ao servidor da monetização (functions/handlers/anuncios.js e
// lembreteTeste.js). O servidor decide TUDO que tem regra: frequência do
// intersticial, se o vídeo pode render recompensa, quanto vale o bônus. O app
// só pergunta e mostra.
//
// Custo: a config vem numa callable só (getEstadoAnuncios), uma vez por
// sessão e por uid. Nada de listener em config.

import { callFirebaseFunction } from '../../utils/firebaseFunctionCaller';

let _estado = { uid: null, promessa: null };

/**
 * Config pública + se esta conta vê anúncio. Cacheada por sessão/uid.
 * Falha ⇒ tudo desligado (o app segue sem anúncio, nunca quebra).
 * @param {string} uid dono
 * @param {{forcar?: boolean}} [opts]
 * @return {Promise<object>}
 */
export function carregarEstadoAnuncios(uid, opts = {}) {
  if (!uid) return Promise.resolve(ESTADO_DESLIGADO);
  if (!opts.forcar && _estado.uid === uid && _estado.promessa) return _estado.promessa;
  const promessa = callFirebaseFunction('getEstadoAnuncios', {})
    .then((r) => ({ ...ESTADO_DESLIGADO, ...(r || {}), cfg: { ...ESTADO_DESLIGADO.cfg, ...((r && r.cfg) || {}) } }))
    .catch(() => {
      // Não cacheia a falha por muito tempo: a próxima tentativa refaz.
      if (_estado.promessa === promessa) _estado = { uid: null, promessa: null };
      return ESTADO_DESLIGADO;
    });
  _estado = { uid, promessa };
  return promessa;
}

export function esquecerEstadoAnuncios() {
  _estado = { uid: null, promessa: null };
}

export const ESTADO_DESLIGADO = Object.freeze({
  ok: false,
  podeAds: false,
  modoTeste: false,
  tier: null,
  ofertaDisponivelHoje: false,
  cfg: {
    ADMOB_ATIVO: false,
    INTERSTICIAL_ATIVO: false,
    ADMOB_REWARDED_ATIVO: false,
    GATILHOS: {},
    CAMPANHA_PROPRIA_PRIORIDADE: true,
    BONUS_ATIVO: false,
    BONUS_MULT_EXIBIDO: 2.5,
    BONUS_ORIGENS: [],
    CONGELAR_VIDEO_ATIVO: false,
    SCANFOOD_VIDEO_ATIVO: false,
    OFERTA_PREMIUM_ATIVA: false,
    TRIAL_ATIVO: false,
    TRIAL_DIAS: 7,
    LEMBRETE_TESTE_ATIVO: false,
    LINK_EXTERNO_IOS: false,
    LINK_EXTERNO_ANDROID: false,
    LINK_EXTERNO_URL: 'https://www.lesvita.com/assinar',
    AD_UNITS: { ANDROID: {}, IOS: {} },
    MAX_AD_CONTENT_RATING: 'G',
    NPA_SEM_CONSENTIMENTO: true,
  },
});

/** DECIDIR | EXIBIDO | FALHOU. */
export function intersticial(gatilho, fase, formato) {
  return callFirebaseFunction('anuncioIntersticial', { gatilho, fase, formato });
}

/**
 * Abre uma sessão de vídeo com recompensa (BONUS | CONGELAR | SCANFOOD).
 * `atividadeId` (só BONUS): o bônus da atividade GPS inteira, no lugar do
 * eventKey de um crédito só — o servidor soma treino + km daquela atividade.
 */
export function prepararRewarded(tipo, eventKeyOrigem, plataforma, antecipado = false,
  atividadeId = null) {
  return callFirebaseFunction('prepararRewarded', {
    tipo, eventKeyOrigem, plataforma, antecipado,
    ...(atividadeId ? { atividadeId } : null),
  });
}

/** Contador do funil/receita. Fire-and-forget: nunca lança. */
export function registrarMetrica(evento, extra = {}) {
  try {
    callFirebaseFunction('registrarMetricaAnuncio', { evento, ...extra }).catch(() => {});
  } catch {
    /* métrica nunca derruba tela */
  }
}

/** Receita por impressão paga (AdMob AdImpression). */
export function registrarReceita(formato, dados) {
  if (!dados || !(Number(dados.valueMicros) > 0)) return;
  registrarMetrica('RECEITA', {
    receita: {
      formato,
      valueMicros: Number(dados.valueMicros),
      currencyCode: dados.currencyCode,
      precision: dados.precision,
    },
  });
}

/** Lembrete do fim do teste: SALVAR | CONFIRMAR_APP | STATUS | DESCARTAR. */
export function lembreteTeste(acao, extra = {}) {
  return callFirebaseFunction('lembreteTeste', { acao, ...extra });
}

/** Situação do congelamento (mesma régua do servidor). */
export function statusCongelamento() {
  return callFirebaseFunction('getStatusCongelamento', {});
}
